import { FunctionComponent, Fragment } from 'react'
import { useHistory } from 'react-router'
import { LightHeader } from '../../components/LightHeader'
import { ChangePasswordForm } from '../../components/ChangePasswordForm'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useStyles } from './useStyles'
import { getCache } from '@/utils/cache'
import { TimeZoneGMT } from '@conexasaude/hero-web'

const ChangePassword: FunctionComponent = () => {
  const { clinic } = useAuthContext()
  const { container } = useStyles()
  const { push } = useHistory()

  const hasPasswordConfirmed = getCache('passwordConfirmed')

  if (hasPasswordConfirmed) {
    return (
      <Fragment>
        <LightHeader uniqueCode={clinic.uniqueCode} redirectTo="/" />

        <div css={container}>
          <div className="change-password__noise"></div>
          <ChangePasswordForm />
          <div className="tz-section">
            <TimeZoneGMT />
          </div>
        </div>
      </Fragment>
    )
  }

  push('/')
  return null
}

export default ChangePassword
